// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__2VNRa","colMin":"styles_colMin__28kWT","colCheckbox":"styles_colCheckbox__3sCTC"};